// src/modules/gotop/gotop.jubesa.js
// -------------------------------------------------------------
// 🌟 Jubesa GoTop v1.0 — JS sincronizado con SCSS (0.78s)
// -------------------------------------------------------------
export function initGoTop() {
  const goTop = document.querySelector('.jubesa__GoTop');
  if (!goTop) return;

  let isVisible = false;
  let isAnimating = false;

  const SHOW = 120;
  const HIDE = 40;

  const APPEARING_TIME = 780; // 0.78s
  const FADING_TIME = 1180; // 0.78s + 0.40s delay

  const showGoTop = () => {
    if (isVisible || isAnimating) return;

    isAnimating = true;

    goTop.classList.remove('fading', 'faded');
    goTop.classList.add('pulsing');

    setTimeout(() => {
      isVisible = true;
      isAnimating = false;
    }, APPEARING_TIME);
  };

  const hideGoTop = () => {
    if (!isVisible || isAnimating) return;

    isAnimating = true;

    goTop.classList.remove('pulsing');
    goTop.classList.add('fading');

    setTimeout(() => {
      goTop.classList.add('faded');
      goTop.classList.remove('fading');

      isVisible = false;
      isAnimating = false;
    }, FADING_TIME);
  };

  window.addEventListener('scroll', () => {
    const y = window.scrollY;

    if (y > SHOW) {
      showGoTop();
    } else if (y < HIDE) {
      hideGoTop();
    }
  });

  goTop.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

document.addEventListener('DOMContentLoaded', initGoTop);
